import { useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { useOpenHuddleNotes } from '../data/huddle-notes';
import { useSession } from '../lib/session';
import { LazyCanvasEditor } from './LazyCanvasEditor';
import { Icon } from './Icon';

/**
 * A HIVAS JEGYZETE - oldalpanel a hivas mellett (versenyaudit H4).
 *
 * Kozos vaszon: aki a hivasban bent van, ugyanazt latja es irja, valos
 * idoben. A hivas utan a csatorna vasznai kozott marad, es a csatorna
 * hivas-soran egy "Jegyzet" gomb vezet vissza hozza.
 */
export function HuddleNotes({ huddleId, onClose }: { huddleId: string; onClose: () => void }) {
  const me = useSession().data?.user;
  const open = useOpenHuddleNotes();
  const queryClient = useQueryClient();

  useEffect(() => {
    open.mutate(huddleId, {
      // A csatorna hivas-sora most mar "Jegyzet" gombot mutathat.
      onSuccess: () => void queryClient.invalidateQueries({ queryKey: ['huddle-notes'] }),
    });
    // Hivasonkent egyszer: a mutacio-objektum minden rendereleskor uj.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [huddleId]);

  const canvas = open.data;

  return (
    <aside className="flex shrink-0 flex-col max-sm:absolute max-sm:inset-0 max-sm:z-30 max-sm:bg-surface-raised border-l border-border-soft bg-surface-raised sm:w-[28rem]">
      <header className="flex items-center gap-2 border-b border-border-soft px-3 py-2.5">
        <span className="text-ink-faint">
          <Icon name="canvas" size="sm" />
        </span>
        <div className="min-w-0 flex-1">
          <p className="truncate text-sm font-semibold">Jegyzetvászon</p>
          <p className="truncate text-2xs text-ink-faint">
            Közös – a hívás után a csatorna vásznai között marad.
          </p>
        </div>
        <button
          type="button"
          onClick={onClose}
          aria-label="Jegyzetvászon bezárása"
          className="rounded-control p-1 text-ink-muted hover:text-ink"
        >
          <Icon name="bezaras" size="sm" />
        </button>
      </header>

      <div className="min-h-0 flex-1 overflow-y-auto px-4 py-3">
        {open.isError ? (
          <p role="alert" className="text-sm text-danger">
            {open.error instanceof Error ? open.error.message : 'A jegyzet nem nyitható meg.'}
          </p>
        ) : !canvas || !me ? (
          <p className="text-sm text-ink-muted">Jegyzet megnyitása…</p>
        ) : (
          <LazyCanvasEditor key={canvas.id} canvas={canvas} me={me} canEdit />
        )}
      </div>
    </aside>
  );
}
